export enum TaskTableSelection {
  toDo = 'toDo',
  complete = 'complete'
}